import { Container, Form, Rating, TextArea } from '@mairistem/composants';
import { Panel, type PanelClass } from '@mairistem/finances-utils';
import React from 'react';

interface ImpactEnvironnementComponentProps {
	data: {
		impactEnvironnement?: number;
		impactEnvironnementTexte?: string;
	};
	handlePin: () => void;
	onChange?: (updatedData: { [key: string]: any }) => void;
	panel: PanelClass;
}

const ImpactEnvironnementComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: ImpactEnvironnementComponentProps) => {
	const handleChange = (_e, { name, value }) => onChange?.({ [name]: value });

	const handleRate = (_e, { name, rating }) => onChange?.({ [name]: rating });

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Container textAlign="center">
				<Rating
					key="impactEnvironnement"
					name="impactEnvironnement"
					rating={data?.impactEnvironnement ?? 0}
					onRate={handleRate}
					maxRating={5}
					data-testid="impactEnvironnementProjet"
					size="massive"
					icon="star"
					clearable
				/>
			</Container>
			<Form>
				<Form.Field
					key="impactEnvironnementTexte"
					name="impactEnvironnementTexte"
					value={data?.impactEnvironnementTexte ?? ''}
					fluid
					// @ts-expect-error
					control={TextArea}
					onChange={handleChange}
					data-testid="impactEnvironnementTexteProjet"
					rows={2}
				/>
			</Form>
		</Panel>
	);
};

export default ImpactEnvironnementComponent;
